import { render } from "./PerDiemManagement.vue?vue&type=template&id=2f851c2f"
import script from "./PerDiemManagement.vue?vue&type=script&lang=js"
export * from "./PerDiemManagement.vue?vue&type=script&lang=js"

import "./PerDiemManagement.vue?vue&type=style&index=0&id=2f851c2f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__